export const adoptionLabelModelData = function () {
  return {
    adoptionLabelList: []
  }
}
